import React from 'react';
import { initReactApp } from 'shared/util/ApplicationInit';
import { Loader } from './Loader';

const render = initReactApp(() => <Loader />, 'hawk-recommendations');

render();

// optional, use this to enable hot reloading
if ((module as any).hot) {
	(module as any).hot.accept('./Loader', () => {
		render();
	});
}
